import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  MessageResult,
} from 'common/repositories/common.model';

import {
  TransactionCategoryDeleteInput,
  TransactionCategoryModel,
  TransactionCategoryMutationInput,
  TransactionCategoryUpdateInput,
} from './model';

export function useCreateTransactionCategory(
  options?: UseMutationOptions<
    ApiResult<TransactionCategoryModel>,
    ApiError,
    TransactionCategoryMutationInput
  >,
): UseMutationResult<
  ApiResult<TransactionCategoryModel>,
  ApiError,
  TransactionCategoryMutationInput
> {
  return useMutation<
    ApiResult<TransactionCategoryModel>,
    ApiError,
    TransactionCategoryMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'transaction-categories',
      method: 'POST',
      body,
      classType: TransactionCategoryModel,
    });
  }, options);
}

export function useUpdateTransactionCategory(
  options?: UseMutationOptions<
    ApiResult<TransactionCategoryModel>,
    ApiError,
    TransactionCategoryUpdateInput
  >,
): UseMutationResult<
  ApiResult<TransactionCategoryModel>,
  ApiError,
  TransactionCategoryUpdateInput
> {
  return useMutation<
    ApiResult<TransactionCategoryModel>,
    ApiError,
    TransactionCategoryUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `transaction-categories/${body.id}`,
      method: 'PUT',
      body: body.body,
      classType: TransactionCategoryModel,
    });
  }, options);
}

export function useDeleteTransactionCategory(
  options?: UseMutationOptions<
    ApiResult<MessageResult>,
    ApiError,
    TransactionCategoryDeleteInput
  >,
): UseMutationResult<
  ApiResult<MessageResult>,
  ApiError,
  TransactionCategoryDeleteInput
> {
  return useMutation<
    ApiResult<MessageResult>,
    ApiError,
    TransactionCategoryDeleteInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `transaction-categories/${body.id}`,
      method: 'DELETE',
    });
  }, options);
}
